import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    permissions: JSON.parse(localStorage.getItem("permissions")) || [],
    token:
      localStorage.getItem("token") || sessionStorage.getItem("token") || "",
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
  },
  mutations: {
    SET_PERMISSON(state, arr) {
      state.permissions = arr;
      localStorage.setItem("permissions", JSON.stringify(arr));
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    clearToken(state) {
      state.token = "";
      state.userInfo = {};
      localStorage.clear();
      sessionStorage.clear();
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem("userInfo", userInfo);
    },
  },
  actions: {},
  modules: {},
});
